"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.forEach = void 0;
function forEach(mapper) {
    const iterator = this[Symbol.iterator]();
    let item;
    while (!(item = iterator.next()).done)
        mapper(item.value);
}
exports.forEach = forEach;
